export const setCourtData = (value) => {
  return {
    type: "SET_COURT_DATA",
    payload: { data: value },
  };
};
export const setBookingForUpdatedSlots = (value) => {
  return {
    type: "SET_BOOKINGS_COURT_DATA",
    payload: { data: value },
  };
};

export const setSlotsTypesData = (value) => {
  return {
    type: "SET_SLOTS_TYPES_DATA",
    payload: { data: value },
  };
};
export const setCourtCount = (value) => {
  return {
    type: "SET_COURT_COUNT",
    payload: { data: value },
  };
};
export const setCourtsData = (value) => {
  return {
    type: "SET_COURTS_DATA",
    payload: { data: value },
  };
};

export const setAllCourtsData = (value) => {
  return {
    type: 'SET_ALL_COURTS_DATA',
    payload: { data: value },
  };
};

export const setCourtsSlotsForWeek = (value) => {
  return {
    type: 'SET_COURTS_SLOTS_FOR_WEEK',
    payload: { data: value },
  };
};

export const setCourtDurations = (value) => {
  return {
    type: "SET_COURT_DURATIONS",
    payload: { data: value },
  };
};

export const setCourtsSlotsForBookingPageView = (value) => {
  return {
    type: "SET_COURTS_SLOTS_FOR_BOOKING_PAGE_VIEW",
    payload: { data: value },
  };
};
export const setCourtsSlotsBlockedForBookingPageView = (value) => {
  return {
    type: "SET_BLOCKED_SLOTS_FOR_BOOKING_PAGE_VIEW",
    payload: { data: value },
  };
};
export const setCourtsSlotsForBookingWindow = (value) => {
  return {
    type: "SET_COURTS_SLOTS_FOR_BOOKING_WINDOW",
    payload: { data: value },
  };
};
export const setCoachingSummary = (value) => {
  return {
    type: "SET_COURTS_COACHING_SUMMARY",
    payload: { data: value },
  };
};
export const getDataAgain = (value) => {
  return {
    type: "GET_DATA_AGAIN",
    payload: { data: value },
  };
};


export const toggleBookCourtModal = () => {
  return {
    type: "TOGGLE_BOOK_COURT_MODAL",
  };
};